import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class PreloaderService {

    preloaderVisible = false;

    triggerPreloader() {
        this.preloaderVisible = true;
        setTimeout(() => {
            this.preloaderVisible = false;
        }, 2000);
    }
}